import { tns } from "tiny-slider/src/tiny-slider.module";
import SamplePDF from "../components/SamplesIframe";

/**
 *  Samples Observer
 */
if (document.querySelector(".section-samples")) {
	tns({
		container: "#samples-slider",
		items: 3,
		gutter: 30,
		navPosition: "bottom",
		controlsText: ["", ""],
		responsive: {
			320: {
				items: 1,
				gutter: 0,
				nav: true,
				controls: false
			},
			660: {
				items: 2,
				gutter: 30,
				nav: true,
				controls: false
			},
			768: {
				nav: false,
				controls: true
			},
			940: {
				items: 2
			},
			1000: {
				items: 3
			}
		}
	});

	// PDF Container for Samples
	SamplePDF({
		sampleSection: document.querySelector(".section-samples"),
		sampleButton: "[data-fancybox]"
	});
}
